import styled, { css } from 'styled-components';

const statuses = {
  default: '',
  success: css`
    border-color: ${({ theme }) => theme.success_300};
  `,
  error: css`
    border-color: ${({ theme }) => theme.danger_500};
  `,
};

export const Main = styled.div<{
  $status?: 'default' | 'success' | 'error';
  $clearBorder?: boolean;
}>`
  display: flex;
  flex: 1;
  gap: 25px;
  flex-wrap: wrap;

  ${({ $clearBorder }) =>
    $clearBorder
      ? null
      : css`
          padding: 10px 20px;
          border: 1px solid ${({ theme }) => theme.neutral_300};
          border-radius: 10px;
          background-color: ${({ theme }) => theme.neutral_100};
        `}

  ${({ $status }) => $status && statuses[$status]}
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 100;
  gap: 6px;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex: 1;
  gap: 25px;
`;

export const InnerContainer = styled.div`
  display: flex;
  justify-content: center;

  flex: 1;
`;

export const InfosWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  flex: 100;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TextWrapper = styled.div`
  display: flex;
`;

const smallSize = '23px';
const largeSize = '160px';

const sizes = {
  small: css`
    width: ${smallSize};
  `,
  medium: css`
    width: calc(${largeSize} - ${smallSize});
  `,
  large: css`
    width: ${largeSize};
  `,
};

export const TextContainer = styled.div<{
  $size?: 'small' | 'medium' | 'large';
  $invalid?: boolean;
}>`
  ${({ $size }) => $size && sizes[$size]}
  ${({ $invalid }) =>
    $invalid &&
    css`
      text-decoration: line-through;
      opacity: 0.7;
    `}
`;
